"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionTitle = void 0;
var React = __importStar(require("react"));
var Disclosure_1 = require("reakit/Disclosure");
var Flex_1 = require("../Flex");
var icons_1 = require("../icons");
var useAccordionContext_1 = require("./useAccordionContext");
var AccordionTitle = function (_a) {
    var children = _a.children;
    var accordionDisclosure = (0, useAccordionContext_1.useAccordionContext)();
    return (React.createElement(Disclosure_1.Disclosure, __assign({}, accordionDisclosure, { as: Flex_1.Flex, width: '100%', alignItems: 'center', justifyContent: 'space-between', style: { cursor: 'pointer' } }, (accordionDisclosure.disabled && { color: 'n200' })),
        React.createElement(Flex_1.Flex, { alignItems: 'center' }, children),
        accordionDisclosure.visible ? (React.createElement(icons_1.ArrowDropUpIcon, null)) : (React.createElement(icons_1.ArrowDropDownIcon, null))));
};
exports.AccordionTitle = AccordionTitle;
//# sourceMappingURL=AccordionTitle.js.map